/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams, useLocation} from 'react-router-dom'
import AgentInfo from './AgentInfo'
import ProductInfo from './ProductInfo'
import SalesChannelInfo from './SalesChannelInfo'
import {
  GET_SALES_CHANNEL_BY_ID,
  GET_CLIENT_ALLOWED_COMPONENTS,
} from '../../../../../utils/GraphQLAPI'
import {useLazyQuery} from '@apollo/client'
import backIcon from '../../../../../_metronic/images/back_icon.svg'
import AgentLeaderList from '../../../SharedPages/AgentLeaderList'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
const EditSalesChannel = () => {
  const salesChannelInfoTitle = 'Sales Channel Info'
  const productInfoTitle = 'Product Info'
  const agentInfoTitle = 'Agent Info'
  const agentLeaderTitle = 'Agent Leader'
  const [tab, setTab] = useState<any>(salesChannelInfoTitle)
  const [salesChannelData, setSalesChannelData] = useState<any>([])
  const [isSparks, setIsSparks] = useState<any>(false)
  const navigate = useNavigate()
  const getUrlParams = useParams()
  const location: any = useLocation()
  const IsSolar = location.state.isSolarProduct

  const handleTab = (targetTab: any) => {
    setTab(targetTab)
  }
  const [getClientAllowedComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setIsSparks(data?.getClientAllowedComponents.includes('customerBillImageToSalesChannel'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getClientAllowedComponents()
  }, [])

  useEffect(() => {
    getSalesChannelById()
  }, [])

  const fetchSalesChannel = () => {
    getSalesChannelById()
  }

  const salesId = localStorage.getItem('salesEditId')

  useEffect(() => {
    !salesId && navigate(`/${getUrlParams.adminUser}/sales-channel-list`)
    return () => localStorage.removeItem('salesEditId')
  }, [])

  const [getSalesChannelById, {refetch}] = useLazyQuery(GET_SALES_CHANNEL_BY_ID, {
    fetchPolicy: 'network-only',
    variables: {
      salesChannelId: localStorage.getItem('salesEditId'),
    },
    onCompleted: (data) => {
      setSalesChannelData(data.getSalesChannelById)
    },
  })

  return (
    <>
      <div className='tab'>
        <div className='h-48px d-flex flex-column' style={{height: '48px', marginBottom: '30px'}}>
          <div className='d-flex'>
            <a
              className='svg-icon svg-icon-3 svg-icon-muted me-2 mt-4 align-items-center'
              style={{cursor: 'pointer'}}
              onClick={() => navigate(`/systemadmin/sales-channel-list`)}
            >
              <img src={backIcon} alt='back' />
            </a>
            <div className='ms-4'>
              <div
                className='w-115px h-22px'
                style={{fontSize: '18px', fontWeight: '600', color: '#181C32'}}
              >
                {salesChannelData.salesChannelName}
              </div>
              <div
                className='w-109px h-20px fw-500 lh-20px fs-12px'
                style={{fontSize: '12px', fontWeight: '500', color: '#A1A5B7'}}
              >
                {' '}
                {`Home - Sales Channel - ${tab}`}
              </div>
            </div>
          </div>
        </div>

        <ul
          className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
          role='tablist'
        >
          <li className='nav-item'>
            <a
              className={clsx(`nav-link cursor-pointer text-gray-600 fs-4`, {
                active: tab === salesChannelInfoTitle,
              })}
              onClick={() => handleTab(salesChannelInfoTitle)}
              role='tab'
            >
              {salesChannelInfoTitle}
            </a>
          </li>
          <li className='nav-item'>
            <a
              className={clsx(`nav-link cursor-pointer text-gray-600 fs-4`, {
                active: tab === productInfoTitle,
              })}
              onClick={() => handleTab(productInfoTitle)}
              role='tab'
            >
              {productInfoTitle}
            </a>
          </li>
          <li className='nav-item'>
            <a
              className={clsx(`nav-link cursor-pointer text-gray-600 fs-4`, {
                active: tab === agentLeaderTitle,
              })}
              onClick={() => handleTab(agentLeaderTitle)}
              role='tab'
            >
              {agentLeaderTitle}
            </a>
          </li>
          <li className='nav-item'>
            <a
              className={clsx(`nav-link cursor-pointer text-gray-600 fs-4`, {
                active: tab === agentInfoTitle,
              })}
              onClick={() => handleTab(agentInfoTitle)}
              role='tab'
            >
              {agentInfoTitle}
            </a>
          </li>
        </ul>
      </div>
      <div className='card mt-5'>
        <div className='card-body'>
          <div className='tab-content pt-3'>
            <div className={clsx('tab-pane', {active: tab === salesChannelInfoTitle})}>
              <SalesChannelInfo
                salesData={salesChannelData}
                isSolarProduct={IsSolar}
                isSparks={isSparks}
              />
            </div>
            <div className={clsx('tab-pane', {active: tab === productInfoTitle})}>
              <ProductInfo fetchSalesChannel={fetchSalesChannel} salesData={salesChannelData} />
            </div>
            <div className={clsx('tab-pane', {active: tab === agentLeaderTitle})}>
              <AgentLeaderList showBreadCrumbs={false} />
            </div>
            <div className={clsx('tab-pane', {active: tab === agentInfoTitle})}>
              <AgentInfo
                salesData={salesChannelData}
                agentLeaders={salesChannelData?.agentLeaders}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditSalesChannel
